// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__33oip","textBlock":"Navbar_textBlock__MVc3X","Link":"Navbar_Link__8PE7D"};